import { useUserContextStore } from '@/shared/user-context';

import { RouteNames } from '../routeNames';

export function useVisibilityManagementGuard() {
  const { facilities } = useUserContextStore();

  if (facilities.length === 1) {
    return {
      name: RouteNames.VISIBILITY_MANAGEMENT_FACILITY,
      params: { id: facilities[0].apiClientId, facilityId: facilities[0].id },
    };
  }

  return true;
}
